<div class="row">
  <div *ngIf="isLoading" class="col-12 loading-container d-flex justify-content-center my-3">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3">Loading VCC dashboard data...</span>
  </div>

  <div *ngIf="isError && !isLoading" class="col-12 error-container d-flex justify-content-center align-items-center my-3">
    <mat-icon color="warn">error</mat-icon>
    <span class="ml-2">Failed to load VCC dashboard data. </span>
    <button mat-button color="primary" (click)="refreshData()">Refresh</button>
  </div>

  <div *ngIf="!isLoading" class="col-12 d-flex justify-content-between align-items-center mb-2">
    <div class="flex-center">
      @if (dateFilterText) {
        <widget-info id="vcc-date-text-widget-info" text="{{dateFilterText}}" [title]="titleWidget" textSub="Total days: {{totalDays}}"
          color="primary-300" icon="calendar_month">
        </widget-info>
      } @else {
        <widget-info id="vcc-date-text-widget-info" text="{{releasedDateFrom}} - {{formattedTodayDate}}" [title]="titleWidget" textSub="Total days: {{totalDays}}"
          color="primary-300" icon="calendar_month">
        </widget-info>
      }
    </div>

    <button mat-icon-button color="primary" title="Refresh all charts" (click)="refreshData()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div *ngIf="!isLoading" class="row">
    <div class="col-md-6 mt-24">
      <funding-vcc-chart></funding-vcc-chart>
    </div>
    <div class="col-md-6 mt-24 ml-2">
      <financial-balances-vcc-list></financial-balances-vcc-list>
    </div>
  </div>
  <div *ngIf="!isLoading" class="row">
    <div class="col-md-6 mt-24">
      <matching-vcc-chart></matching-vcc-chart>
    </div>
    <div class="col-md-6 mt-24">
      <aggregated-vcc-chart></aggregated-vcc-chart>
    </div>
  </div>
  <div *ngIf="!isLoading" class="row">
    <div class="col-md-6 mt-24">
      <circulation-vcc-chart></circulation-vcc-chart>
    </div>
  </div>
</div>
